import React, { useState } from 'react';
import { string } from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';
import { twitterPageURL } from '../../util/urlHelpers';
import config from '../../config';
import {
  IconSocialMediaFacebook,
  IconSocialMediaInstagram,
  IconSocialMediaTwitter,
  Logo,
  ExternalLink,
  NamedLink,
  Button
} from '../../components';

import IconSocialMediaTikTok from '../IconSocialMediaTikTok/IconSocialMediaTikTok';

import css from './Footer.module.css';
import IconSocialMediaLinkedIn from '../IconSocialMediaLinkedIn/IconSocialMediaLinkedIn';
import Feedback from '../TypeformPopup/Feedback'


const renderSocialMediaLinks = intl => {
  const { siteFacebookPage, siteInstagramPage, siteTwitterHandle } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  const goToFb = intl.formatMessage({ id: 'Footer.goToFacebook' });
  const goToInsta = intl.formatMessage({ id: 'Footer.goToInstagram' });
  const goToTwitter = intl.formatMessage({ id: 'Footer.goToTwitter' });

  const fbLink = siteFacebookPage ? (
    <ExternalLink key="linkToFacebook" href={siteFacebookPage} className={css.icon} title={goToFb}>
      <IconSocialMediaFacebook />
    </ExternalLink>
  ) : null;

  const twitterLink = siteTwitterPage ? (
    <ExternalLink
      key="linkToTwitter"
      href={siteTwitterPage}
      className={css.icon}
      title={goToTwitter}
    >
      <IconSocialMediaTwitter />
    </ExternalLink>
  ) : null;

  const instragramLink = siteInstagramPage ? (
    <ExternalLink
      key="linkToInstagram"
      href={siteInstagramPage}
      className={css.icon}
      title={goToInsta}
    >
      <IconSocialMediaInstagram />
    </ExternalLink>
  ) : null;
  return [fbLink, twitterLink, instragramLink].filter(v => v != null);
};

const Footer = props => {
  const { rootClassName, className, intl } = props;
  const socialMediaLinks = renderSocialMediaLinks(intl);
  const classes = classNames(rootClassName || css.root, className);
  const [email, setEmail] = useState("")
  const [sendNewsLetterText, setSendNewsLetterText] = useState("")

  const handleChange = (e) => {
    setEmail(e.target.value)
  }


  const onSubmit = async () => {

    const isEmailValid = email.includes("@") && email.includes(".");

    if(email === "" || !isEmailValid){
      setEmail("")
      setSendNewsLetterText("Please insert a valid email adress")
    }else {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
                        to: 'info@theappbuddy.com', // Change to your recipient
                        from: 'info@theappbuddy.com', // Change to your verified sender
                        subject: `${email} wants to subscribe to your newsletter`,
                        text: `${email} wants to subscribe to your newsletter`
                      })
                 }
  
    fetch('/api/sendgrid-email', requestOptions)
      .then(resp => resp.text())
      .then(resp => {
          setEmail("")
          setSendNewsLetterText("Thanks for joining the AppBuddy community!")
      }).catch(error => {
        console.log(error.stack)
      });
  }
}

  return (
    <div className={classes}>
      <div className={css.topBorderWrapper}>
        <div className={css.content}>
          {/* <div className={css.someLiksMobile}>{socialMediaLinks}</div> */}
          <div className={css.links}>

{/* 
            <div className={css.organization} id="organization">
              <NamedLink name="LandingPage" className={css.logoLink}> */}
                {/* <span className={css.logo}>
                  <Logo format="desktop" />
                </span> */}
              {/* </NamedLink> */}
              {/* <div className={css.organizationInfo}> */}
                {/* <p className={css.organizationDescription}>
                  <FormattedMessage id="Footer.organizationDescription" />
                </p> */}
                {/* <p className={css.organizationCopyright}>
                  <NamedLink name="LandingPage" className={css.copyrightLink}>
                    <FormattedMessage id="Footer.copyright" />
                  </NamedLink>
                </p> */}
              {/* </div> */}
            {/* </div> */}
            
            
{/* _________________________________________________________________________________________________________________________________________________ */}
            <div className={css.searches}>

                <h3>Explore</h3>
            <ul className={css.list}>
                  {/* <li className={css.listItem}>
                  <NamedLink name="AboutPage" className={css.link}>
                    <FormattedMessage id="Footer.toAboutPage" />
                  </NamedLink>
                </li> */}
                <li className={css.listItem}>
                  <NamedLink name="FaqHelperPage" className={css.link}>
                    <FormattedMessage id="Footer.toBecomeHelperPage" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="FaqPage" className={css.link}>
                    <FormattedMessage id="Footer.toFAQPage" />
                  </NamedLink>
                </li>
                {/* <li className={css.listItem}>
                  <NamedLink name="LandingPage" className={css.link}>
                    <FormattedMessage id="Footer.toFAQPage" />
                  </NamedLink>
                </li> */}
                {/* <li className={css.listItem}>
                  <NamedLink name="LandingPage" className={css.link}>
                    <FormattedMessage id="Footer.toHelpPage" />
                  </NamedLink>
                </li> */}
                {/* <li className={css.listItem}>
                  <NamedLink name="AboutPage" to={{ hash: '#contact' }} className={css.link}>
                    <FormattedMessage id="Footer.toContactPage" />
                  </NamedLink>
                </li> */}
              </ul>
              
            </div>

{/* _________________________________________________________________________________________________________________________________________________ */}

            <div className={css.infoLinks}>
            <h3>Social Media</h3>
            <ul className={css.socialList}>
                <li className={css.sociaListItem}>
                  <a href="https://www.instagram.com/theappbuddy/" target='_blank'>
                  <IconSocialMediaInstagram/>
                  </a>
                </li>
                <li className={css.sociaListItem}>
                  <a href="https://www.tiktok.com/@theappbuddy?" target='_blank'>
                  <IconSocialMediaTikTok/>
                  </a>
                  </li>
                <li className={css.sociaListItem}>
                  <a href="https://www.linkedin.com/company/78630474/" target='_blank'>
                  <IconSocialMediaLinkedIn/>
                  </a>
                  </li>
              </ul>
              <ul>
                <li><h3>Copyright</h3></li>
                <li className={css.copywright}>© 2021 AppBuddy, Inc. All Rights Reserved.</li>
              </ul>
            </div>       



          <div className={css.infoLinks}>
              <h3>Contact us</h3>
              <ul className={css.list}>
                <li className={css.listItem}>
                  <a>info@theappbuddy.com</a>
                </li>
                <li className={css.listItem}>
                  <a className={css.link}>
                    <Feedback />
                  </a> 
                </li>
              </ul>
            </div>



            


{/* _________________________________________________________________________________________________________________________________________________ */}



            <div className={css.searchesExtra}>
            <h3>Legal</h3>
          <ul className={css.list}>
          <li className={css.listItem}>
                  <NamedLink name="TermsOfUsePage" className={css.link}>
                    <FormattedMessage id="Footer.toTermsOfUsePage" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="TermsConditionsPage" className={css.link}>
                    <FormattedMessage id="Footer.toTermsConditionsPage" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="PrivacyPolicyPage" className={css.link}>
                    <FormattedMessage id="Footer.toPrivacyPolicyPage" />
                  </NamedLink>
                </li>
              </ul>
            </div>


            <div className={css.searchesExtra}>
              <h4 className={css.newsletterTitle}>Subscribe to our newsletter</h4>
              <ul className={css.newsletterList}>
                <li className={css.newsletterListItem}>
                  <input placeholder="Enter email" type="email" value={email} onChange={handleChange}></input>
                </li>
                <li>{sendNewsLetterText}</li>
                <li>
                  <Button className={css.newsletterButton} onClick={onSubmit}>Subscribe</Button>
                </li>
              </ul>
            </div>
{/* _________________________________________________________________________________________________________________________________________________ */}


            

            {/* <div className={css.extraLinks}>
              <div className={css.someLinks}>{socialMediaLinks}</div>
              {/* <div className={css.legalMatters}>
                <ul className={css.tosAndPrivacy}>
                  <li>
                    <NamedLink name="TermsOfServicePage" className={css.legalLink}>
                      <FormattedMessage id="Footer.termsOfUse" />
                    </NamedLink>
                  </li>
                  <li>
                    <NamedLink name="PrivacyPolicyPage" className={css.legalLink}>
                      <FormattedMessage id="Footer.privacyPolicy" />
                    </NamedLink>
                  </li>
                </ul>
              </div> */}
            {/* </div>  */}
            
          </div>
          
          {/* <div className={css.copyrightAndTermsMobile}>
            <NamedLink name="LandingPage" className={css.organizationCopyrightMobile}>
              <FormattedMessage id="Footer.copyright" />
            </NamedLink> */}
            {/* <div className={css.tosAndPrivacyMobile}>
              <NamedLink name="PrivacyPolicyPage" className={css.privacy}>
                <FormattedMessage id="Footer.privacy" />
              </NamedLink>
              <NamedLink name="TermsOfServicePage" className={css.terms}>
                <FormattedMessage id="Footer.terms" />
              </NamedLink>
            </div> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

Footer.defaultProps = {
  rootClassName: null,
  className: null,
};

Footer.propTypes = {
  rootClassName: string,
  className: string,
  intl: intlShape.isRequired,
};

export default injectIntl(Footer);
